// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3xmPQ","label":"Radio_label__tJ3FY","checkMark":"Radio_checkMark__1fxXi","disabled":"Radio_disabled__1Gcvw"};